import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { showError } from "../../../../redux/common/actions";
import { bulkDeleteModelTasks } from "services/models/modelDetails/modelTasks";

/**
 * Runs a bulk delete against the whole selection in one request, then refreshes
 * the list. A partial result is reported rather than silently swallowed: the
 * endpoint skips IDs it cannot delete instead of failing the batch.
 */
const useBulkTaskDelete = ({ modelVersionId, onDeleted }) => {
	const dispatch = useDispatch();
	const [isDeleting, setIsDeleting] = useState(false);

	const deleteTasks = useCallback(
		async (taskIds) => {
			setIsDeleting(true);
			try {
				const response = await bulkDeleteModelTasks({
					modelVersionId,
					taskIds,
				});
				if (!response?.status) {
					dispatch(
						showError(response?.data?.title || "Could not remove the selected tasks")
					);
					return false;
				}
				const skipped = response.data?.skippedIDs?.length ?? 0;
				if (skipped > 0) {
					dispatch(
						showError(`${skipped} of ${taskIds.length} could not be removed`)
					);
				}
				await onDeleted();
				return true;
			} finally {
				setIsDeleting(false);
			}
		},
		[dispatch, modelVersionId, onDeleted]
	);

	return { deleteTasks, isDeleting };
};

export default useBulkTaskDelete;
